import { Injectable, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../popup/popup.component';
import { ApiService } from './api.service';
import { Constant } from '../constants/constant';
@Injectable({
  providedIn: 'root'
})

export class CommonService {
  formControlFields: any;
  modalHeader: any;
  popupDataGetComp: EventEmitter<number> = new EventEmitter();
  fieldDetailsArray: any
  entryType: any;
  ProducerBRG: any;
  Allowedit: any;
  GetpopupData: any;
  storevalueViewClient: any;
  viewBondReportData: any;
  bondNo: any;
  constructor(private NgxSpinner: NgxSpinnerService,
    private snackBar: MatSnackBar, public dialog: MatDialog,
    private http_client: ApiService) {

  }
  openDialog(data): void {
    console.dir('open dialog');
    this.GetpopupData = data;
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.sendPopupData(result);
      console.dir(result);
      //this.animal = result;
    });
  }
  sendPopupData(result) {
    this.popupDataGetComp.emit(result);
  }

  openSnackBar(message: string, type) {
    //to show anchor link text replace null with a string value
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: [type],
      horizontalPosition: 'right',
      verticalPosition: 'top',
      direction: 'ltr',
    });
    // const config = new MatSnackBarConfig();
    // config.panelClass = ['background-red'];
    // config.duration = 5000;
    // config.direction=left
    // this.snackBar.open(message, action, config);
    // this.snackBar.openFromComponent
  }

  dismissSnackBar() {
    this.snackBar.dismiss();
  }

  async getListData(url: string): Promise<any> {
    try {
      const response = await this.http_client.getData(Constant.new_base_url + "api/List/" + url, 'params');
      return response;
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }

  async filterListData(url: string, event: any): Promise<any> {

    try {
      const response = await this.http_client.getData(Constant.new_base_url +
        "api/List/" + url + "/" + event);
      return response;
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }

  async filter(url: string, event: any): Promise<any> {
    try {
      const response = await this.http_client.getData(Constant.new_base_url +
        "api/List/" + url + "/" + event, 'params');
      return response;
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }
  formatNumber(tel) {
    debugger
    if (!tel) { return ''; }

    var value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    var country, city, number;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = '(' + value.slice(0, 3) + ')';
        number = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = '(' + value.slice(1, 4) + ')';
        number = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = '(' + value.slice(3, 5) + ')';
        number = value.slice(5);
        break;

      default:
        return tel;
    }

    if (country == 1) {
      country = "";
      number = city + ' ' + number.slice(0, 3) + '-' + number.slice(3);
    } else {
      number = country + ' ' + city + ' ' + number.slice(0, 3) + '-' + number.slice(3);
    }


    return number;
  };


  showloader() {
    this.NgxSpinner.show();
  }
  hideloader() {
    this.NgxSpinner.hide();
  }
}
